exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Checkbox {\n  display: block; }\n  .Checkbox input {\n    margin-right: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/style/Checkbox.scss
// module id = 1704
// module chunks = 0